export const CUSTOMER_EMAIL_CAPTURED_EVENT_NAME = 'SubscribedToNewsletter';

function validate(email) {
    if (typeof email !== 'string') {
        throw new TypeError(`Argument 'email' should be a string, ${typeof email} provided`);
    }
}

class CustomerEmailCapturedEvent extends Event {
    #email;
    constructor(email) {
        validate(email);
        super(CUSTOMER_EMAIL_CAPTURED_EVENT_NAME);
        this.#email = this.constructor.normalize(email);
    }

    static normalize(email) {
        return email.trim().toLowerCase();
    }

    get email() {
        return this.#email;
    }
}

export default CustomerEmailCapturedEvent;
